import React, { useState } from 'react';
import { Button, Badge, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import idly from '../../../../images/items/idly.png';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import TimePickerWrapper from '../../../components/Forms/Pickers/TimePicker';



const Rework = ({ show, onClose }) => {
    const [colorChange] = useState(null);


    const staff = [
        { value: 0, label: "Priya" },
        { value: 1, label: "Mithra" },
        { value: 2, label: "Dharshini" },
    ]

    const [selectedOption, setSelectedOption] = useState(null);

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    return (
        <Modal show={show} size="lg">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Rework</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-3">
                        <div className="col-lg-12">
                            <div className="d-flex align-items-center justify-content-start gap-2">
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]}
                                >
                                    <div data-src={idly} className='border rounded px-1 py-0'>
                                        <img src={idly} alt="Podi Idly" className='cursor-pointer w-90px h-90px' />
                                    </div>
                                </LightGallery>
                                <div>
                                    <label className='text-black  fs-5 font-w400'>
                                        <span className='font-w500'>Item</span>
                                        <span className='me-2 ms-2'>-</span>
                                        <span className='text-primary font-w500'>Podi Idly</span>
                                    </label>
                                    <label className='text-gray-600 me-3 ms-3'>|</label>
                                    <label className='text-black font-w400 fs-5'>
                                        <span className='font-w500'>Category</span>
                                        <span className='me-2 ms-2'>-</span>
                                        <span className='text-gray-800'>Steamed Food</span></label>
                                    <label className='text-black me-3 ms-3'>|</label>
                                    <label className='text-black font-w400 fs-5'>
                                        <span className='font-w500'>Sub Category</span>
                                        <span className='me-2 ms-2'>-</span>
                                        <span className='text-gray-800'>Idly</span></label>
                                    <div className='d-block mt-1'>
                                        <label className='text-black font-w400 fs-6'>
                                            <span className='font-w500'>Product</span>
                                            <span className='me-2 ms-2'>-</span>
                                            <span className='text-gray-800'>Break Box Mini</span></label>
                                        <label className='text-black me-3 ms-3'>|</label>
                                        <label className='text-black font-w400 fs-6'>
                                            <span className='font-w500'>Product Category</span>
                                            <span className='me-2 ms-2'>-</span>
                                            <span className='text-gray-800'> Break Box</span></label>
                                    </div>
                                    <div className='d-block'>
                                        <label className='text-black font-w400 fs-7'>Unit</label>
                                        <Badge bg="warning" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>No's</Badge>
                                        <label className='text-black me-3 ms-3'>|</label>
                                        <label className='text-black font-w400 fs-7'>Weight</label>
                                        <Badge bg="success" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>70 gms</Badge>
                                        <label className='text-black me-3 ms-3'>|</label>
                                        <label className='text-black font-w400 fs-7'>Size</label>
                                        <Badge bg="info" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>9 cm</Badge>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Start Time<span className="required">*</span></label>
                            <div>
                                <TimePickerWrapper />
                            </div>
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">End Time<span className="required">*</span></label>
                            <div>
                                <TimePickerWrapper />
                            </div>
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description<span className="required">*</span></label>
                            <textarea className="form-control" placeholder="Enter Description" />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Update Rework<i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Rework;
